<div class="mobile-pagination" *ngIf="totalRecords > 0">
  <div class="pagination-info">
    Showing {{ skip + 1 }} to {{ getPaginationEndIndex() }} of {{ totalRecords }} entries
  </div>

  <div class="pagination-controls">
    <button class="pagination-btn" [disabled]="skip === 0" (click)="goToFirstPage()">
      &laquo;&laquo;
    </button>

    <button class="pagination-btn" [disabled]="skip === 0" (click)="goToPreviousPage()">
      &laquo;
    </button>

    <div class="page-numbers">
      <button *ngFor="let page of getVisiblePages(); trackBy: trackByPage" class="pagination-btn page-number"
        [ngClass]="{'active': isCurrentPage(page)}" (click)="goToPageNumber(page)">
        {{ page }}
      </button>
    </div>

    <button class="pagination-btn" [disabled]="skip + take >= totalRecords" (click)="goToNextPage()">
      &raquo;
    </button>

    <button class="pagination-btn" [disabled]="skip + take >= totalRecords" (click)="goToLastPage()">
      &raquo;&raquo;
    </button>
  </div>

  <div class="rows-per-page">
    <select class="rows-selector" [formControl]="rowsControl">
      <option *ngFor="let option of rowsPerPageOptions" [value]="option">
        {{ option }}
      </option>
    </select>
  </div>
</div>